module.exports = __webpack_public_path__ + "static/media/cc.6e855468.svg";